"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  calendar: {
    boxShadow: theme.calendar.boxShadow,
    boxSizing: 'border-box',
    borderRadius: '5px',
    borderWidth: 1,
    borderStyle: 'solid',
    borderTop: 'none',
    borderColor: `${theme.calendar.borderColor} !important`,
    userSelect: 'none',
    backgroundColor: theme.calendar.mainBgColor,
    flexDirection: 'column'
  },
  visible: {
    display: 'inline-flex'
  },
  hidden: {
    display: 'none'
  },
  header: {
    boxSizing: 'border-box',
    width: '100%',
    margin: '-9px -9px 0 -9px',
    borderRadius: '5px 5px 0 0',
    border: `1px solid ${theme.calendar.borderColor}`,
    backgroundColor: `${theme.calendar.headerBgColor} !important`,
    '&.isRange': {
      '& > *:last-child': {
        paddingTop: 8
      }
    }
  },
  confirmButton: {
    width: '100%',
    height: 40
  },
  medium: {
    width: 320,
    padding: '8px 8px 16px 8px',
    '& $header': {
      paddingTop: 8,
      paddingBottom: 8
    }
  },
  small: {
    width: 240,
    padding: 11,
    '& $header': {
      margin: '-12px -12px 0 -12px'
    },
    '& $confirmButton': {
      width: '100%',
      height: 36
    }
  }
});

exports.default = _default;